import React, { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { REACT_APP_API_URL } from 'src/constants';

import { UploadIcon } from 'src/assets';
import './customUpload.scss';

export const CustomUpload = (props) => {
  const { value, onChange = () => {}, label = '', required = false } = props;

  const { t } = useTranslation('title');

  const [file, setFile] = useState();

  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    setFile(file);
    onChange(file);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const normalizeFileValue = useCallback(() => {
    if (typeof value === 'object') {
      return URL.createObjectURL(value);
    }

    return REACT_APP_API_URL + value;
  }, [value]);

  return (
    <div className="custom-upload__wrapper">
      {label ? (
        <label htmlFor={label} className="custom-input__label">
          {label}
        </label>
      ) : null}

      <div className="custom-upload">
        <input
          id={label}
          type="file"
          ref={fileInputRef}
          style={{
            position: 'absolute',
            zIndex: -1,
          }}
          onChange={handleFileChange}
          required={value ? false : required}
          accept="image/png, image/svg+xml"
        />

        <img src={normalizeFileValue()} alt={normalizeFileValue()} className="custom-upload__img" />

        <button onClick={handleClick} className="custom-upload__button" type="button">
          {file ? file?.name?.slice(0, 20) + '...' : null}
          {!file && value ? value?.slice(0, 20) + '...' : null}
          {!file && !value ? t('upload') : null}

          <img src={UploadIcon} alt={UploadIcon} />
        </button>
      </div>
    </div>
  );
};
